import React, { useMemo, useState } from 'react';
import RNZoomImageViewer from 'react-native-image-zoom-viewer';
import useCachedImgURL from 'src/components/10-atoms/image/useCachedImgURL';
import ModalBase from 'src/components/10-atoms/modals/ModalBase';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
import { clamp } from 'src/utils/math';
import ImageThumbnailList from './ImageThumbnailList';
const EMPTY_ARRAY = [];
const ImageViewerSession = ({ initialIndex, images, imageUrls, onClose, backgroundColor, }) => {
    const [index, setIndex] = useState(initialIndex);
    useEffectWithCtx((_, ctxRef) => {
        if (images.length > 1) {
            const handler = (ev) => {
                let newIndex = ctxRef.current.index;
                switch (ev.key) {
                    case 'ArrowRight':
                        newIndex += 1;
                        break;
                    case 'ArrowLeft':
                        newIndex -= 1;
                        break;
                }
                setIndex(clamp(newIndex, 0, images.length - 1));
            };
            document.addEventListener('keydown', handler);
            return () => {
                document.removeEventListener('keydown', handler);
            };
        }
    }, { index }, [images]);
    return (React.createElement(React.Fragment, null,
        React.createElement(RNZoomImageViewer, { index: index, imageUrls: imageUrls, enableSwipeDown: true, onSwipeDown: onClose, swipeDownThreshold: 100, backgroundColor: backgroundColor, renderIndicator: () => React.createElement(React.Fragment, null), onChange: nextIndex => {
                if (typeof nextIndex === 'number') {
                    setIndex(nextIndex);
                }
            } }),
        images.length > 1 ? (React.createElement(ImageThumbnailList, { index: index, images: images, onThumbnailPress: setIndex })) : undefined));
};
const ImageViewer = ({ images, initialIndex, visible, onClose, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const imageUris = useMemo(() => images.map(image => image.uri), [images]);
    const cachedImages = useCachedImgURL(visible ? imageUris : EMPTY_ARRAY);
    const imageUrls = useMemo(() => cachedImages.data.map((imgUri, i) => ({ url: imageUris[i] ?? imgUri ?? '' })), [cachedImages, imageUris]);
    const sessionKey = `${initialIndex}|${imageUris.join('\0')}`;
    return (React.createElement(ModalBase, { animationIn: "zoomIn", animationOut: "zoomOut", propagateSwipe: false, isVisible: visible, onDismiss: onClose, showCloseButton: true }, visible && imageUrls.length > 0 ? (React.createElement(ImageViewerSession, { key: sessionKey, initialIndex: initialIndex, images: images, imageUrls: imageUrls, onClose: onClose, backgroundColor: theme.palette.background.dark })) : undefined));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default ImageViewer;
